import { titleCaseString } from "common/helpers/String";

export const getPrettyName = (option: string): string => {
  return prettyName[option] || titleCaseString(option);
};

export const prettyName: { [details: string]: string } = {
  // Bread Crumbs
  orgs: "Configuration",
  jobs: "Customers",
  info: "Information",
  settings: "Global Settings",
  child_orgs: "Child Organizations",
  analytics: "Analytics",
  estimator: "Estimator",
  measurements: "Measurements",
  documents: "Documents",
  presentations: "Presentations",
  financing: "Financing",
  tools: "Tools",
  sharing: "Sharing Preferences",
  users: "Users",
  job_statuses: "Job Statuses",
  access_management: "Access Management",
  integrations: "Integrations",
  products: "Products",
  webhooks: "Webhooks",
  dashboard: "Dashboard",
  payments: "Payments",
  calendar: "Calendar",
  signed_docs: "Signatures",
  accesses: "Accesses",
  system_settings: "System Settings",
  profile: "Profile",
  images: "Photos",
  appointments: "Appointments",
  notes: "Notes",
  history: "History",
  "design-tools": "Design Tools",
  signatures: "Signatures",
  chargebacks: "Chargebacks",
  deposits: "Deposits",
  finance: "Finance",
  tasks: "Tasks",

  // Payment Providers
  paysimple: "PaySimple",
  cardconnect: "Clover Connect",

  // Org SidebarMenu
  orgSidebar_info: "Information",
  orgSidebar_settings: "Global Settings",
  orgSidebar_child_orgs: "Child Organizations",
  orgSidebar_jobs: "Customers",
  orgSidebar_analytics: "Analytics",
  orgSidebar_estimator: "Estimator",
  orgSidebar_measurements: "Measurements",
  orgSidebar_documents: "Documents",
  orgSidebar_presentations: "Presentations",
  orgSidebar_financing: "Financing & Pricing",
  orgSidebar_tools: "Tools",
  orgSidebar_sharing: "Sharing Preferences",
  orgSidebar_users: "Users",
  orgSidebar_job_statuses: "Job Statuses",
  orgSidebar_access_management: "Access Management",
  orgSidebar_integrations: "Integrations",
  orgSidebar_products: "Products",
  orgSidebar_webhooks: "Webhooks",

  // Job SidebarMenu
  jobSidebar_info: "Information",
  jobSidebar_appointments: "Appointments",
  jobSidebar_financing: "Financing",
  jobSidebar_tools: "Tools",
  jobSidebar_images: "Photos",
  jobSidebar_documents: "Documents",
  jobSidebar_measurements: "Measurements",
  jobSidebar_notes: "Notes",
  jobSidebar_inspection: "Inspection",
  jobSidebar_history: "History",
  jobSidebar_estimates: "Estimates",
  jobSidebar_presentations: "Presentations",
  "jobSidebar_design-tools": "Design Tools",
  jobSidebar_signatures: "Signatures",

  // Measurements
  roofing: "Roofing",
  siding: "Siding",
  windows: "Windows",
  doors: "Doors",
  roof_faces: "Roof faces",
  walls: "Walls",
  fencing: "Fencing",
  sunroom: "Sunroom",
  rooms: "Rooms",
  decks: "Decks",
  pools: "Pools",
  roof_total_area: "Roof Total Area",
  roof_5pw_total_area: "Roof Area + 5% Waste",
  roof_10pw_total_area: "Roof Area + 10% Waste",
  roof_12pw_total_area: "Roof Area + 12% Waste",
  roof_15pw_total_area: "Roof Area + 15% Waste",
  roof_20pw_total_area: "Roof Area + 20% Waste",
  roof_0_area: "0/12 Pitch Area",
  roof_1_area: "1/12 Pitch Area",
  roof_2_area: "2/12 Pitch Area",
  roof_3_area: "3/12 Pitch Area",
  roof_4_area: "4/12 Pitch Area",
  roof_5_area: "5/12 Pitch Area",
  roof_6_area: "6/12 Pitch Area",
  roof_7_area: "7/12 Pitch Area",
  roof_8_area: "8/12 Pitch Area",
  roof_9_area: "9/12 Pitch Area",
  roof_10_area: "10/12 Pitch Area",
  roof_11_area: "11/12 Pitch Area",
  roof_12_area: "12/12 Pitch Area",
  roof_13_area: "13/12 Pitch Area",
  roof_14_area: "14/12 Pitch Area",
  roof_15_area: "15/12 Pitch Area",
  roof_16_area: "16/12 Pitch Area",
  roof_17_area: "17/12 Pitch Area",
  roof_18_area: "18/12 Pitch Area",
  roof_19_area: "19/12 Pitch Area",
  roof_20_area: "20/12 Pitch Area",
  roof_21_area: "21/12 Pitch Area",
  roof_22_area: "22/12 Pitch Area",
  roof_23_area: "23/12 Pitch Area",
  roof_24_area: "24/12 Pitch Area",
  roof_25_area: "25/12 Pitch Area",
  roof_26p_area: "26/12+ Pitch Area",
  roof_flat_shallow_area: "Roof Flat Shallow Area",
  roof_flat_area: "Roof Flat Area",
  roof_low_slope_area: "Roof Low Slope Area",
  roof_average_slope_area: "Roof Average Slope Area",
  roof_steep_slope_area: "Roof Steep Slope Area",
  roof_ultra_steep_slope_area: "Roof Ultra Steep Slope Area",
  roof_high_roof_area: "Roof High Roof Area",
  roof_sloped_area: "Roof Sloped Area",
  roof_10pw_sloped_area: "Roof Sloped Area + 10% Waste",
  roof_79_area: "Roof 7-9/12 Pitch Area",
  roof_1012_area: "Roof 10-12/12 Pitch Area",
  roof_13p_area: "Roof 13/12+ Pitch Area",
  roof_eave: "Roof Eave",
  roof_rake: "Roof Rake",
  roof_perimeter: "Roof Perimeter",
  roof_ridge: "Roof Ridge",
  roof_hip: "Roof Hip",
  roof_ridge_hip: "Roof Ridge Hip",
  roof_valley: "Roof Valley",
  roof_valley_eave: "Roof Valley Eave",
  roof_valley_eave_rake: "Roof Valley Eave Rake",
  roof_step_flashing: "Roof Step Flashing",
  roof_headwall_flashing: "Roof Headwall Flashing",
  roof_total_flashing: "Roof Total Flashing",
  roof_gutter_miters: "Roof Gutter Miters",
  roof_downspouts: "Roof Downspouts",
  roof_downspout_elbows: "Roof Downspout Elbows",
  siding_total_area: "Siding Total Area",
  siding_5pw_total_area: "Siding Area + 5% Waste",
  siding_10pw_total_area: "Siding Area + 10% Waste",
  siding_15pw_total_area: "Siding Area + 15% Waste",
  siding_18pw_total_area: "Siding Area + 18% Waste",
  siding_inside_corner_qty: "Siding Inside Corner Quantity",
  siding_inside_corner_length: "Siding Inside Corner Length",
  siding_outside_corner_qty: "Siding Outside Corner Quantity",
  siding_outside_corner_length: "Siding Outside Corner Length",
  siding_level_starter: "Siding Level Starter",
  siding_sloped_trim: "Siding Sloped Trim",
  siding_vertical_trim: "Siding Vertical Trim",
  siding_level_frieze_board: "Siding Level Frieze Board",
  siding_sloped_frieze_board: "Siding Sloped Frieze Board",
  siding_frieze_board: "Siding Frieze Board",
  siding_opening_qty: "Siding Opening Quantity",
  siding_windows_qty: "Siding Windows Quantity",
  siding_doors_qty: "Siding Doors Quantity",
  siding_garage_doors_qty: "Siding Garage Doors Quantity",
  siding_opening_tops_length: "Siding Opening Tops Length",
  siding_opening_sills_length: "Siding Opening Sills Length",
  siding_opening_sides_length: "Siding Opening Sides Length",
  siding_shutter_qty: "Siding Shutter Quantity",
  siding_shutter_area: "Siding Shutter Area",
  siding_vents_qty: "Siding Vents Quantity",
  siding_vents_area: "Siding Vents Area",
  siding_soffit_eaves: "Siding Soffit Eaves",
  siding_soffit_level_frieze: "Siding Soffit Level Frieze",
  siding_soffit_rakes: "Siding Soffit Rakes",
  siding_soffit_sloped_frieze: "Siding Soffit Sloped Frieze",
  siding_soffit_total: "Siding Soffit Total",

  // Measurement tools
  annotator: "Window-inator",
  elevation_scaling: "Opening Measuring",
  rapid_area: "Rapid Area",
  satellite_measure: "Satellite Measure",
  sidinginator: "Siding-inator",
  fencing_tool: "Fencing Measurement Tool",

  // Measurement systems
  imperial: "Imperial",
  metric: "Metric",

  // Fill PDF options
  fill_contract: "Agreement",
  fill_inspection: "Inspection",
  fill_estimate: "Proposal",

  // Admin
  contract: "Agreement",
  inspection: "Inspection",

  // Users
  org_admin: "Org Admin",
  admin: "Admin",
  user: "User",
  salesrep: "Salesrep",
  custom: "Custom",

  // Billable
  billable: "Billable",
  free: "Free",
  estimates: "Estimates",
  leads: "Leads",

  // Sharing preferences
  basic: "Basic",
  premium: "Premium",
  BROWSER: "Browser Window",
  USER_SELECT: "User Selection",
  enabled: "Enabled",
  disabled: "Disabled",
  mute: "Mute",
  IN_BROWSER: "Chrome Plugin",
  NATIVE: "Desktop App",
  "peer-to-peer": "Peer-to-peer",
  "group-small": "Group-Small",
  group: "Group",

  //Org Global Settings
  customer_document_signed: "Send signed agreement notification to customer",
  signable_document_signed: "Send signable document notification to customer",
  never: "Never",
  always: "Always",
  by_choice: "Default to No",
  by_default: "Default to Yes",
  estimate_amount: "Amount",
  appointment_time: "Appointment Time",
  manual: "Manual Choice",

  //Org Estimator
  use_sales_tax: "Use Sales Tax",
  default_rate: "Tax Rate",
  default_taxable_amount: "Taxable Type",
  product: "Product Total",
  labor: "Labor Total",
  product_labor: "Product + Labor Total",
  customer_only: "Presentation Mode Only",
  company_only: "Edit Mode Only",
  replace: "Replace",
  merge: "Merge",
  ask: "Ask",
  markup_enabled: "Enable percent markup pricing",
  customer_main_only: "Presentation Mode - Included Estimate Groups Only",
  customer_option_only: "Presentation Mode - Not Included Estimate Groups Only",
  company_main_only: "Edit Mode - Included Estimate Groups Only",
  company_option_only: "Edit Mode - Not Included Estimate Groups Only",
  company_customer_main: "Edit and Presentation Mode - Included Estimate Groups Only",
  company_customer_option: "Edit and Presentation Mode - Not Included Estimate Groups Only",
  "org.estimator.standard": "Default (Estimate Level)",
  "org.estimator.estimate_group": "Estimate Group (Each estimate group will have its own set of values)",

  // Org Access Management
  "job_menu.enabled": "Job Menu",
  full: "Full Estimator",
  window: "Window Estimator",
  multiple_groups: "Multiple Groups",
  leads_module: "One Click Leads",
  estimate_module: "One Click Contractor",

  // Misc
  none: "None",

  // Org statuses
  created: "Created",
  paid: "Paid",
  waiting_on_materials: "Waiting on Materials",
  build_in_progress: "Build in Progress",
  build_completed: "Build Completed",
  ongoing_support: "Ongoing Support",
  driving_utilization: "Driving Utilization",
  training_scheduled: "Training Scheduled",
  suspended: "Suspended",
  awol: "AWOL",
  canceled: "Canceled",
  retention: "Retention",
  held_to_contract: "Held to Contract",
  collections: "Collections",

  // Job Events
  "job.created": "Created",
  "job.document_created": "Document Created",
  "job.assigned": "Assigned",
  "job.image_created": "Image Created",
  "job.updated": "Updated",
  "job.status_changed": "Status Changed",
  "job.resulted": "Resulted",

  // Estimate Events
  "estimate.created": "Created",
  "estimate.updated": "Updated",
  "estimate.pdf_generated": "PDF Generated",
  "estimate.manual_trigger": "Manual Trigger",

  // Signable Document Events
  "signable_document.signed": "Signed",

  // Signed Document Events
  "signed_document.signed": "Signed",

  // Payment Events
  "payment.created": "Created",
  "payment.refunded": "Refunded",
  "payment.ach_return": "ACH Return",
  "payment.chargeback": "Chargeback",

  enforce_required_magic_wand: "Enforce Required PDF Fields in Magic Wand Tool",
  enforce_required_signable_doc: "Enforce Required PDF Fields in Signatures Tab",

  // Tools
  renoworks_masking: "Order Renoworks Design",
  show_renoworks: "Renoworks",
  eagleview_order: "Order EagleView",
  eagleview_order_decra: "Order Eagleview: Decra",
  google_maps: "Google Maps",
  bing_ortho: "Bing Ortho",
  bing_birdseye: "Bing Birdseye",
  zoom_earth: "Zoom Earth",
  terra_server: "Terra Server",
  pictometry_online: "Pictometry Online",
  pictometry_connect: "Pictometry Connect",
  chameleon: "GAF Chameleon",
  chameleon_v2: "OCC Chameleon",
  chi_overhead_door: "C.H.I. Overhead Door",
  map_developers_area: "Map Developers Area Tool",
  ca_3d_demo: "Chief Architect 3D Demo",
  daltile_demo: "daltile 3D Demo",
  abbeycarpet_demo: "Abbey Carpet Demo",
  renuit_cabinet_demo: "Renuit Cabinet Refacing Demo",
  zillow: "Zillow",
  trulia: "Trulia",
  greensky_link: "GreenSky Financing",
  homeguard: "HomeGuard Windows & Doors",
  plygem_visualizer: "PlyGem Visualizer",
  oc_design_eyeq: "Owens Corning DESIGN EyeQ",
  gaf_vhr: "GAF Virtual Home Remodeler",
  gaf_vhr_link: "GAF Virtual Home Remodeler",
  gaf_vent_calc_link: "GAF Attic Ventilation Calculator",
  provia: "ProVia",
  provia_non_portal: "ProVia (Non-Portal)",
  hover: "HOVER",
  quick_measure: "GAF QuickMeasure",
  quick_measure_roofing: "GAF QuickMeasure",
  houzz_link: "Houzz",
  home_advisor_link: "Home Advisor",
  angies_list_link: "Angie's List",
  gaf_quick_measure_link: "GAF QuickMeasure",
  gaf_smart_money_link: "GAF SmartMoney",
  sketchup: "Sketchup",
  global_transport_link: "Global Transport VT",
  service_finance_link: "Service Finance",
  ami_design_showcase_siding: "AMI Design Showcase: Preservation Siding",
  ami_design_showcase_alside_window: "AMI Design Showcase: Alside Windows",
  ami_design_showcase_pres_window: "AMI Design Showcase: Preservation Windows",
  foundation_finance_link: "Foundation Finance Company",
  sighten_solar: "Sighten Solar",
  enerbank_link: "EnerBank",
  pella_portal: "Pella Portal",
  colorview: "CertainTeed Colorview",
  alside_renoworks: "Alside Visualizer",
  advisar_link: "Advisar",
  square_d_link: "Square D",
  lp_smartside_link: "LP BuildSmart",
  lp_smartside_visualizer: "LP SmartSide Visualizer",
  sunrise_configurator: "Sunrise Windows",
  royal_homeplay: "HomePlay by Royal",
  sherwin_williams_colorsnap: "Sherwin Williams COLORSNAP",
  york_hvac_link: "York HVAC",
  foundation_finance_dealer_link: "Foundation Finance Company Dealer",
  sigler_online_link: "Sigler Online",
  hearth_financing_link: "Hearth Financing",
  wellsfargo_link: "Wells Fargo",
  iko_roof_viewer: "IKO Roof Viewer TM",
  square_d_ezsel: "Square D EZ Selector",
  paragon_visualizer: "Paragon Visualizer",
  timbertech_deck_designer: "TimberTech Deck Designer",
  timbertech_worry_less: "TimberTech: Worry Less",
  roof_scope_roofing: "RoofScope",
  plnar_interior: "plnar",
  plnar: "plnar",
  interior: "Interior",
  lowes_deck_designer: "Lowe's Deck Designer",
  thermatru_design_your_door: "ThermaTru Design Your Door",
  pella_lowes_product_designer: "Pella Lowe's Product Designer",

  // Reports
  sky_measure: "Sky Measure",
  sky_measure_roofing: "CoreLogic SkyMeasure Roofing",
  eagleview_roofing: "EagleView",
  eagleview: "EagleView",

  // Estimator ACL
  price_comparison: "Enable Price Comparison",

  // Global Settings menu
  statistics: "Global Statistics",
  reports: "Reports",
  patterns: "Patterns",

  // Pattern Types
  cf_job_resulting: "Job Resulting",

  // Discount
  discount_percent: "Percentage without limit",
  discount_flat: "Flat Amount",
  discount_percent_limit: "Percentage with limit",

  // Product
  percent: "Percent",

  // Units of Measure
  ea: "Each",
  sqft: "Square Foot",
  lft: "Lineal Foot",
  ui: "United Inch",
  in: "Inch",
  sq: "Square",
  pair: "Pair",
  sash: "Sash",
  mile: "Mile",
  gal: "Gallon",
  layer: "Layer",
  hr: "Hour",
  cm: "Centimeters",
  m: "Meters",
  sqm: "Square Meter",
  km: "Kilometers",
  l: "Liter",
  all: "All",
  w: "Watts",
  kW: "Kilowatts",
  day: "Day",

  // Bracket Type
  unset_bt: "Unset",
  ui_bt: "UI Based",
  width_height_bt: "Width/Height Based",

  // Product Option Type
  per_quantity: "Per Line Item Quantity",
  per: "Per Line Item",
  per_ui: "Per UI",
  per_sqft: "Per SQFT",

  // Integrations
  assigned: "Assigned",
  updated: "Updated",
  status_changed: "Status Changed",
  image_created: "Image Created",
  document_created: "Document Created",
  pdf_generated: "PDF Generated",
  manual_trigger: "Manual Trigger",
  signed: "Signed",
  ach: "ACH",
  email_text_to_pay: "Email/Text to Pay",

  jobs_uiux: "Jobs UI/UX",

  // Option Group Selection Type
  multi: "Multiple",
  single: "Single",

  // Email Provider
  postmark: "Email",
  twilio: "Text",

  // Email Statuses
  Delivery: "Delivered",
  Bounce: "Bounced",
  SpamComplaint: "Reported as Spam",
  Open: "Opened",
};
